import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const selectors = {
  header: '.js-header:not(.is-initialized)',
  openBtn: '.js-header-open',
  closeBtn: '.js-header-close',
  anchor: '.js-anchor',
  menu: '.js-header-menu',
};

const classes = {
  hidden: 'is-hidden',
  open: 'is-open',
  menuOpen: 'has-menu-open',
};

let resizeTimeout;

const getNavHeight = header => {
  clearTimeout(resizeTimeout);

  resizeTimeout = setTimeout(() => {
    const navHeight = header.clientHeight;
    document.documentElement.style.setProperty('--navH', `${navHeight}px`);
  }, 100);
};

const onResize = header => {
  getNavHeight(header);
};

const showHideNav = header => {
  const navTrigger =
    document.querySelector(selectors.navTrigger) ?? document.body;

  gsap.to(header, {
    scrollTrigger: {
      id: 'navTrigger',
      trigger: navTrigger,
      start: 'top top',
      end: 'max',
      onUpdate: self => {
        if (self.direction === -1) {
          header.classList.remove(classes.hidden);
        } else {
          header.classList.add(classes.hidden);
        }
      },
    },
  });
};

const init = () => {
  const header = document.querySelector(selectors.header);

  if (!header) return;

  header.classList.add('is-initialized');

  const openBtn = header.querySelector(selectors.openBtn);
  const closeBtn = header.querySelector(selectors.closeBtn);

  openBtn.addEventListener('pointerup', () => {
    header.classList.add(classes.open);
    document.body.classList.add(classes.menuOpen);
  });

  closeBtn.addEventListener('pointerup', () => {
    header.classList.remove(classes.open);
    document.body.classList.remove(classes.menuOpen);
  });

  setTimeout(() => {
    onResize(header);
  }, 500);

  window.addEventListener('resize', () => {
    onResize(header);
  });

  showHideNav(header);

  const menu = header.querySelector(selectors.menu);
  const anchors = header.querySelectorAll(selectors.anchor);
  anchors.forEach(a => {
    a.addEventListener('pointerup', () => {
      if (!menu.modal) return;
      menu.modal.closeModal();
      header.classList.remove(classes.open);
      document.body.classList.remove(classes.menuOpen);
    });
  });
};

const module = () => {
  init();
  document.addEventListener('domUpdated', init);
};

export default module;
